import * as React from 'react'
import { GridApiCommunity } from '../../../models/api/gridApiCommunity'
import { useGridApiOptionHandler } from '../../utils/useGridApiEventHandler'
import { DataGridProcessedProps } from '../../../models/props/DataGridProps'

export function useGridEvents(
  apiRef: React.MutableRefObject<GridApiCommunity>,
  props: Pick<
    DataGridProcessedProps,
    | 'onColumnHeaderClick'
    | 'onColumnHeaderDoubleClick'
    | 'onCellClick'
    | 'onCellDoubleClick'
    | 'onCellKeyDown'
    | 'onRowDoubleClick'
    | 'onRowClick'
    | 'onStateChanged'
  >
): void {
  useGridApiOptionHandler(
    apiRef,
    'columnHeaderClick',
    props.onColumnHeaderClick
  )
  useGridApiOptionHandler(
    apiRef,
    'columnHeaderDoubleClick',
    props.onColumnHeaderDoubleClick
  )
  useGridApiOptionHandler(apiRef, 'cellClick', props.onCellClick)
  useGridApiOptionHandler(apiRef, 'cellDoubleClick', props.onCellDoubleClick)
  useGridApiOptionHandler(apiRef, 'cellKeyDown', props.onCellKeyDown)
  useGridApiOptionHandler(apiRef, 'rowDoubleClick', props.onRowDoubleClick)
  useGridApiOptionHandler(apiRef, 'rowClick', props.onRowClick)
  useGridApiOptionHandler(apiRef, 'stateChange', props.onStateChanged)
}
